<template>
  <div class="place-header-background" :style="styles"></div>
</template>
<script>
import { find } from 'lodash'

export default {
  props: {
    url: String
  },
  data() {
    return {
      imageKey: null,
      widthScale: [768, 1280, 1600, 2048, 2560],
      styles: {
        'background-image': 'none'
      }
    }
  },
  methods: {
    initImageKey() {
      this.imageKey = this.url.split('/').pop()
    },
    setBackgroundStyle(url) {
      this.styles["background-image"] = `url(${url})`
    },
    imgUrlWith(width) {
      return this.url.replace('format=auto', `format=auto,width=${width}`)
    },
    preloadBigImage(bigImg = new Image()) {
      bigImg.src = this.imgUrlWith(this.imgMaxWidth)
      bigImg.onload = () => {
        this.setBackgroundStyle(bigImg.src)
        sessionStorage[this.imageKey] = true
      }
    },
    getOptimalWidth(currentWidth) {
      return find(this.widthScale, (v) => {
        if (v >= currentWidth) {
          return currentWidth
        }
      })
    }
  },
  computed: {
    imgMaxWidth() {
      return this.getOptimalWidth(window.outerWidth)
    }
  },
  mounted() {
    if (!!this.url && this.$el.offsetHeight > 0) {
      this.initImageKey();

      if (!sessionStorage[this.imageKey]) {
        this.setBackgroundStyle(this.imgUrlWith(320))
        this.preloadBigImage()
      } else {
        this.setBackgroundStyle(this.imgUrlWith(this.imgMaxWidth))
      }
    }
  }
}
</script>
